// @flow
import InvoicesCreatedModalContainer from './InvoicesCreatedModalContainer';

export default InvoicesCreatedModalContainer;
